import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useContainerCoords} from "components/hooks/useContainerCoords.js";
import {setSelectedZObject} from 'actions/index.js';
import {connect} from 'react-redux';

const ZNumber = ({znumber, number, uxLocked, isSelectedZObject, setSelectedZObject, color, onChange, hideNumber}) => { 
    let ref = useRef(undefined);
    let [value, setValue] = useState(number);
    let [editing, setEditing] = useState(false);

    useEffect(() => {
        window.addEventListener("mouseup", onMouseUp);
        window.addEventListener("mousemove", onMouseMove);

        return () => {
            window.removeEventListener("mouseup", onMouseUp);
            window.removeEventListener("mousemove", onMouseMove);
        };
    }, [setEditing, editing, setValue]);

    useEffect(() => {
        setValue(number);
    }, [number, setValue]);

    const onMouseMove = useCallback(e => {
        if (editing) {
            let {y, number} = editing;
            let {pageY} = e;
            let distY = y - pageY;
            let ratio = distY / y;
            let _number = ratio*(znumber.max - znumber.min) + number;
            _number = Math.max(znumber.min, Math.min(znumber.max, _number));
            if (znumber.round) {
                _number = Math.round(_number);
            }
            if (_number !== znumber._text) {
                znumber.text = _number;
                if (znumber.execute) {
                    znumber.execute();
                }
                setValue(_number);
                if (onChange) {
                    onChange(_number);
                }
            }
        }
    }, [setEditing, editing, setValue, onChange]);

    const onMouseUp = useCallback(e => {
        if (editing) {
            setEditing(false);
        }
    }, [setEditing, editing]);

    return (
        <div
          style={{color}}
          ref={ref}
            onMouseDown={(e) => {
                if (uxLocked) {
                    setEditing({number, y: e.pageY});
                }
                if (znumber.execute) {
                    setSelectedZObject(znumber);
                }
            }}
          className="z-number">
          <div
            style={{
                borderLeftColor: znumber.attributes["secondary-color"]
            }
            }
            onMouseDown={(e) => {
                e.stopPropagation();
                setEditing({number, y: e.pageY});
                if (znumber.execute) {
                    setSelectedZObject(znumber);
                }
            }}
            className={isSelectedZObject ? "selected arrow-right" : "arrow-right"}/>
          {hideNumber ? '' : round(value)}
        </div>
    );
}

const round = (value) => {
    return Math.round(value*1000)/1000;
};

const mapStateToProps = (state, props) => {
  return {
      uxLocked: state.zobject.uxLocked,
      round: props.znumber.round,
      number: props.znumber._text
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedZObject: x => dispatch(setSelectedZObject(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZNumber);
